/*************************************************************/
// NumeroALetras
// The MIT License (MIT)
//
// Copyright (c) 2015 Luis Alfredo Chee
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//
// @author Rodolfo Carmona
// @contributor Jean (jpbadoino@gmail.com)
/*************************************************************/

function Unidades(num) {
  switch (num) {
    case 1:
      return 'UN'
    case 2:
      return 'DOS'
    case 3:
      return 'TRES'
    case 4:
      return 'CUATRO'
    case 5:
      return 'CINCO'
    case 6:
      return 'SEIS'
    case 7:
      return 'SIETE'
    case 8:
      return 'OCHO'
    case 9:
      return 'NUEVE'
  }

  return ''
} // Unidades()

function Decenas(num) {
  const decena = Math.floor(num / 10)
  const unidad = num - decena * 10

  switch (decena) {
    case 1:
      switch (unidad) {
        case 0:
          return 'DIEZ'
        case 1:
          return 'ONCE'
        case 2:
          return 'DOCE'
        case 3:
          return 'TRECE'
        case 4:
          return 'CATORCE'
        case 5:
          return 'QUINCE'
        default:
          return 'DIECI' + Unidades(unidad)
      }
    case 2:
      switch (unidad) {
        case 0:
          return 'VEINTE'
        default:
          return 'VEINTI' + Unidades(unidad)
      }
    case 3:
      return DecenasY('TREINTA', unidad)
    case 4:
      return DecenasY('CUARENTA', unidad)
    case 5:
      return DecenasY('CINCUENTA', unidad)
    case 6:
      return DecenasY('SESENTA', unidad)
    case 7:
      return DecenasY('SETENTA', unidad)
    case 8:
      return DecenasY('OCHENTA', unidad)
    case 9:
      return DecenasY('NOVENTA', unidad)
    case 0:
      return Unidades(unidad)
  }
} // Unidades()

function DecenasY(strSin, numUnidades) {
  if (numUnidades > 0) return strSin + ' Y ' + Unidades(numUnidades)

  return strSin
} // DecenasY()

function Centenas(num) {
  const centenas = Math.floor(num / 100)
  const decenas = num - centenas * 100

  switch (centenas) {
    case 1:
      if (decenas > 0) return 'CIENTO ' + Decenas(decenas)
      return 'CIEN'
    case 2:
      return 'DOSCIENTOS ' + Decenas(decenas)
    case 3:
      return 'TRESCIENTOS ' + Decenas(decenas)
    case 4:
      return 'CUATROCIENTOS ' + Decenas(decenas)
    case 5:
      return 'QUINIENTOS ' + Decenas(decenas)
    case 6:
      return 'SEISCIENTOS ' + Decenas(decenas)
    case 7:
      return 'SETECIENTOS ' + Decenas(decenas)
    case 8:
      return 'OCHOCIENTOS ' + Decenas(decenas)
    case 9:
      return 'NOVECIENTOS ' + Decenas(decenas)
  }

  return Decenas(decenas)
} // Centenas()

function Seccion(num, divisor, strSingular, strPlural) {
  const cientos = Math.floor(num / divisor)
  const resto = num - cientos * divisor

  let letras = ''

  if (cientos > 0) {
    if (cientos > 1) letras = Centenas(cientos) + ' ' + strPlural
    else letras = strSingular
  }

  if (resto > 0) letras += ''

  return letras
} // Seccion()

function Miles(num) {
  const divisor = 1000
  const cientos = Math.floor(num / divisor)
  const resto = num - cientos * divisor

  const strMiles = Seccion(num, divisor, 'UN MIL', 'MIL')
  const strCentenas = Centenas(resto)

  if (strMiles == '') return strCentenas

  return strMiles + ' ' + strCentenas
} // Miles()

function Millones(num) {
  const divisor = 1000000
  const cientos = Math.floor(num / divisor)
  const resto = num - cientos * divisor

  const strMillones = Seccion(num, divisor, 'UN MILLON DE', 'MILLONES DE')
  const strMiles = Miles(resto)

  if (strMillones == '') return strMiles

  return strMillones + ' ' + strMiles
} // Millones()

function NumeroALetras(num) {
  var data = {
    numero: num,
    enteros: Math.floor(num),
    centavos: Math.round(num * 100) - Math.floor(num) * 100,
    letrasCentavos: '',
    letrasMonedaPlural: 'PESOS', // "PESOS", 'Dólares', 'Bolívares', 'etcs'
    letrasMonedaSingular: 'PESO', // "PESOS", 'Dólar', 'Bolivar', 'etc'

    letrasMonedaCentavoPlural: 'CENTAVOS',
    letrasMonedaCentavoSingular: 'CENTAVO',
  }

  if (data.centavos > 0) {
    data.letrasCentavos =
        'CON ' +
        (function() {
          if (data.centavos == 1) {
            return (
              Millones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular
            )
          } else { return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural }
        })()
  }

  if (data.enteros == 0) { return 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos }
  if (data.enteros == 1) {
    return (
      Millones(data.enteros) +
        ' ' +
        data.letrasMonedaSingular +
        ' ' +
        data.letrasCentavos
    )
  } else {
    return (
      Millones(data.enteros) +
        ' ' +
        data.letrasMonedaPlural +
        ' ' +
        data.letrasCentavos
    )
  }
}
const NumeroALetrasCapitalize = num => {
  return Capitalize(NumeroALetras(num))
}

const Capitalize = s => {
  if (typeof s !== 'string') return ''
  s = s.replace(/u00f3/g, 'ó').replace(/u00ed/g, 'í').replace(/u00f1/g, 'ñ')
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

const Traslate = {
  rooms: 'habitaciones',
  bathrooms: 'baños',
  half_bathrooms: 'medios baños',
  parking_spaces: 'cajones de estacionamiento',
  kitchens: 'cocinas',
  dinning_room: 'comedor',
  living_room: 'sala',
  service_yard: 'patio de servicio',
  laundry_room: 'cuarto de lavado',
  studying_room: 'sala de estudio',
  game_room: 'sala de juegos',
  service_room: 'habitación de servicio',
  chimneys: 'chimeneas',
  gym: 'gimnasio',
  hallways: 'pasillos',
  gardens: 'jardines',
  basement: 'sótano',
  garage: 'garaje',
  parking_area: 'área de estacionamiento',
  swimming_pool: 'piscina',
  penthouse: 'ático',
  air_conditioning: 'aire acondicionado',
  elevator: 'ascensor',
  party_room: 'sala de fiestas',
  cinema: 'cine',
  pool: 'picina',
  ludoteca: 'ludoteca',
  conference_room: 'sala de conferencias',
  offices: 'oficinas',
  digging: 'cava',
  integral_kitchen: 'cocina integral',
  tinaco: 'tinaco',
  tank: 'cisterna',
  solar_heater: 'calentador solar',
  boiler: 'boiler',
  solar_panels: 'paneles solares',
  floor_type: 'tipo de piso',
  bathroom_accessories: 'accesorios de baño',
  jacuzzi: 'jacuzzi',
  whirlpool_tub: 'bañera de hidromasaje',
  light: 'luz',
  water: 'agua',
  sewer_system: 'drenaje',
  telephone_line_access: 'acceso a línea telefónica',
  internet_line_access: 'acceso a línea de internet',
  street_lighting: 'alumbrado público',
  sidewalks: 'aceras',
  street: 'calle',
  avenues: 'avenidas',
  is_private: 'es privado',
  has_parking_space: 'tiene plaza de aparcamiento',
  for_how_many: 'para cuantos',
  basic_services: 'servicios basicos',
  additional_services: 'servicios adicionales',
  other_services: 'otros servicios',
  services_included: 'servicios incluidos',
  statutes: 'estatutos',
  description: 'descripción',
}

const formatter = (num) => {
  return '$' + Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

function BlobtoB64(blob) {
  return URL.createObjectURL(blob)
  return new Promise((res, rej) => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onloadend = function() {
      var base64data = reader.result
      res(base64data)
    }
  })
}

const decimalFormat = (number, decimal, isCeil = false) => {
  let newNumber = Number(number)
  newNumber = Math[isCeil ? 'ceil' : 'floor'](newNumber * (10 ** decimal)) / (10 ** decimal)
  return newNumber
}


function MapContentType(type:string) {
  const mime = type?.toLowerCase() || "";

  // Images
  if (mime.startsWith("image/")) {
    return "photo";
  }

  // Videos
  if (mime.startsWith("video/")) {
    return "video";
  }

  // Audio
  if (mime.startsWith("audio/")) {
    return "musica";
  }

  // PDF
  if (mime === "application/pdf") {
    return "doc";
  }

  // Office docs
  const officeTypes = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
    "text/plain",
    "text/csv",
  ];

  if (officeTypes.includes(mime)) {
    return "doc";
  }

  // ZIP / comprimidos
  if (
    mime.includes("zip") ||
    mime.includes("rar") ||
    mime.includes("7z")
  ) {
    return "archivo";
  }

  // Default
  return "otro";
}

function MimeToExtension(mime:string) {
  const map = {
    // Images
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/webp": "webp",
    "image/svg+xml": "svg",

    // Video
    "video/mp4": "mp4",
    "video/webm": "webm",
    "video/quicktime": "mov",

    // Audio
    "audio/mpeg": "mp3",
    "audio/wav": "wav",
    "audio/ogg": "ogg",

    // Docs
    "application/pdf": "pdf",
    "text/plain": "txt",
    "text/csv": "csv",

    // Office
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",

    // Compressed
    "application/zip": "zip",
    "application/x-rar-compressed": "rar",
  };

  return map[mime.toLowerCase()] || "";
}

export default {
  dataURLtoFile,
  BlobtoB64,
  DecimalFormat: decimalFormat,
  PriceFormat: (price) => `${formatter(price)}`,
  NumeroALetras,
  NumeroALetrasCapitalize,
  Capitalize,
  Traslate: str => Capitalize(Traslate[str]),
  MapContentType,
  MimeToExtension,
}
